import Status from './status';

export default ({active, onClick, bonus}) => (
    <div className={`method-20 ${!active ? 'not-available' : ''}`} onClick={e => {
        // toast.dismiss();
        // toast.info('CashApp under maintenance now. Use Chime or Crypto to make deposits');

        if(!active)
            return;

        onClick({
            mode: "methods",
            method: "googlepay-deposit"
        });
    }}>
        <div className="info">
            <div className="icon googlepay"> 
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2679_1176)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.45457 15C6.45457 14.0473 6.61279 13.134 6.89519 12.2773L1.95218 8.50262C0.988815 10.4586 0.446045 12.6626 0.446045 15C0.446045 17.3353 0.988147 19.538 1.95018 21.4926L6.89052 17.7106C6.61079 16.858 6.45457 15.948 6.45457 15Z" fill="#FBBC05"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1335 6.33331C17.2031 6.33331 19.0724 7.06665 20.5412 8.26665L24.8139 3.99998C22.2102 1.73331 18.8721 0.333313 15.1335 0.333313C9.32928 0.333313 4.34087 3.65265 1.95215 8.50265L6.89516 12.2773C8.03411 8.81998 11.2807 6.33331 15.1335 6.33331Z" fill="#EB4335"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1335 23.6667C11.2807 23.6667 8.03411 21.18 6.89516 17.7227L1.95215 21.4967C4.34087 26.3473 9.32928 29.6667 15.1335 29.6667C18.7159 29.6667 22.1361 28.3947 24.7031 26.0113L20.0111 22.384C18.6872 23.218 17.0202 23.6667 15.1335 23.6667Z" fill="#34A853"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.1534 15C29.1534 14.1333 29.0199 13.2 28.8196 12.3333H15.1335V18H23.0114C22.6175 19.932 21.5453 21.4173 20.0111 22.384L24.7031 26.0113C27.3996 23.5086 29.1534 19.7806 29.1534 15Z" fill="#4285F4"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2679_1176">
                            <rect width="30" height="30" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>

            <Status available={active} bonus={0} deposit_bonus={bonus} fee={5} />
        </div>

        <div className="name">Google Pay</div>
    </div>
)